'use strict'

function normalFromPoints( a, b, c, target )
{
  var cb = target || new THREE.Vector3(), ab = new THREE.Vector3();

  cb.subVectors( c, b );
  ab.subVectors( a, b );
  cb.cross( ab );

  cb.normalize();

  return cb;
}


module.exports = normalFromPoints;

